import { render } from "./RecycleCompany.vue?vue&type=template&id=18ea9cea"
import script from "./RecycleCompany.vue?vue&type=script&lang=js"
export * from "./RecycleCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__